import { jsx as t } from "react/jsx-runtime";
import * as o from "@sentry/react";
import n from "react";
class a extends n.Component {
  constructor() {
    super(...arguments), this.state = { error: null };
  }
  static getDerivedStateFromError(r) {
    return { error: r };
  }
  componentDidCatch(r, e) {
    console.error(r, e);
  }
  render() {
    return this.state.error ? typeof this.props.errorComponent == "function" ? this.props.errorComponent({
      error: this.state.error,
      componentStack: "",
      eventId: "",
      resetError: () => this.setState({ error: null })
    }) : this.props.errorComponent : /* @__PURE__ */ t(
      o.ErrorBoundary,
      {
        fallback: this.props.errorComponent,
        beforeCapture: this.props.beforeCapture,
        children: this.props.children
      }
    );
  }
}
export {
  a as ErrorBoundary
};
